import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GestorContenidoService } from 'src/app/services/gestor-contenido.service';
import {
  ContactoAtencionContent,
  getContactoAtencionContent,
} from 'src/app/shared/data/contacto-atencion.content';
declare var $: any;

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false,
})
export class FooterComponent implements OnInit {
  listaLogosFooter: any[] = [];
  constructor(
    private readonly router: Router,
    private readonly _gestorContenido: GestorContenidoService
  ) {}

  ngOnInit(): void {
    this.showModal();
    this.getLogosFooter();
  }

  showModal() {
    $('.info_hover').on('click', function () {
      $('.modal-body').empty();
      const label = $(this).text().trim();
      if (label === 'Información de contacto') {
        const content = getContactoAtencionContent('contacto');
        $('.modal_info_title').text(content.title);
        $('.modal_info_body').append(buildModalListHtml(content));
      } else if (label === 'Líneas de atención') {
        const content = getContactoAtencionContent('atencion');
        $('.modal_info_title').text(content.title);
        $('.modal_info_body').append(buildModalListHtml(content));
      } else if (label === 'Enlaces rápidos') {
        $('.modal_info_title').text('Enlaces rápidos');
        $('.modal_info_body').append(`<ul style="margin-left: 30px;">
          <li>
            <a href="https://www.bancoldex.com/es/contactanos/defensor-del-consumidor-financiero-3740"
            target="_blank" rel="noopener noreferrer">Defensor al consumidor</a><br>
          </li>
        </ul>`);
      }
      $('.modal_info').modal('show');
    });
  }

  closeModal() {
    $('.modal-backdrop').remove();
    $('#politicasModal').modal('hide');
    this.router.navigate(['/home']);
  }

  getLogosFooter() {
    const pagina = 0;
    this._gestorContenido.getLogosFooter(pagina).subscribe(
      (response: any) => {
        const page = response;
        this.listaLogosFooter = page.rows;
      },
      (_error) => {}
    );
  }
}

function buildModalListHtml(content: ContactoAtencionContent): string {
  const items = content.items
    .map((item) => {
      const valueHtml = item.href
        ? `<a href="${item.href}">${escapeHtml(item.value)}</a>`
        : `<p>${escapeHtml(item.value)}</p>`;
      return `<li>
            <strong>${escapeHtml(item.label)}</strong><br>
            ${valueHtml}
          </li>`;
    })
    .join('');
  return `<ul style="display:contents; list-style: none;">${items}</ul>`;
}

function escapeHtml(text: string): string {
  return text
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;');
}
